module.exports = __webpack_public_path__ + "img/flat_work2.4f6721c9.jpg";